export default __webpack_public_path__ + "assets/login-1--arrow-enter-frame-left-login-point-rectangle.png";